module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    attrs: {
      "id": "defaultModal",
      "hide-footer": "",
      "centered": ""
    }
  }, [(_vm.action.action === 'updateScat') ? _c('UpdateSubCategory', {
    attrs: {
      "action": _vm.action
    }
  }) : _vm._e(), _vm._v(" "), (_vm.action.action === 'addCategory') ? _c('CreateCategory', {
    attrs: {
      "action": _vm.action
    }
  }) : _vm._e(), _vm._v(" "), (_vm.action.action === 'addSubcat') ? _c('CreateSubCategory', {
    attrs: {
      "action": _vm.action
    }
  }) : _vm._e(), _vm._v(" "), (_vm.action.action === 'deleteCat') ? _c('DeleteCategory', {
    attrs: {
      "action": _vm.action
    }
  }) : _vm._e(), _vm._v(" "), (_vm.action.action === 'deleteSubCat') ? _c('DeleteSubCategory', {
    attrs: {
      "action": _vm.action
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d0886ebc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/categories/modal/Modal.vue
// module id = 3371
// module chunks = 0